<template>
  <gj-popover
    v-model="visible"
    width="150"
    placement="top"
    trigger="click"
    @close="visible = false, form.costNum = ''">
    <template slot="reference">
      <span class="colorBlue cursor size12">批量</span>
    </template>
    <template>
      <el-form ref="form" :model="form">
        <el-form-item
          :prop="`costNum`"
          :rules="[
            $gjReRule(RE.num(4), '最多四位小数的正数'),
          ]">
          <gj-input maxlength="10" v-model="form.costNum" width="100%">
          </gj-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin-top: 14px;">
        <gj-button size="mini" @click="visible = false, form.costNum = ''">取消</gj-button>
        <gj-button size="mini" type="primary" @click="confirmBatch">确定</gj-button>
      </div>
    </template>
  </gj-popover>
</template>
<script>
import { formRuleMixin } from "@/minxins";
export default {
  name: 'batch-cost',
  mixins: [ formRuleMixin ],
  data() {
    return {
      visible: false,
      form: {
        costNum: ''
      }
    }
  },
  methods: {
    confirmBatch() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form.costNum)
          this.visible = false
        } else {
          return false;
        }
      });
    }
  }
}
</script>